module.exports = __webpack_public_path__ + "img/services-activity-2.a347c629.svg";